import { Delete } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import React from "react";
import FormTextField from "../../Common/FormTextField";
import { useFormConfigContext } from "./ConfigFormContext";

const ConfigSynthesis: React.FC = () => {
  const { control, setValue } = useFormConfigContext();
  return (
    <>
      <div className="flex justify-between items-center">
        <Typography className="text-xl font-semibold">Synthèse</Typography>
        <Button
          color="error"
          onClick={() => setValue("config.synthesis", undefined)}
        >
          <Delete />
        </Button>
      </div>

      <FormTextField
        minRows={4}
        multiline
        control={control}
        name="config.synthesis"
        label="Synthèse"
      />
    </>
  );
};
export default ConfigSynthesis;
